import { setUi } from "@/lib/singularity/ui";
import { configStore, uiStore } from "@/store/store";

export function switchToAdvancedMode() {
  uiStore.setMode({ mode: "builder" });

  iframeBs();

  const url = new URL(window.location.href);
  url.searchParams.delete("singularity");
  window.history.replaceState({}, "", url.toString());
}

export function switchToSingularityMode() {
  iframeBs();
  setUiStoreToSingularityMode();
  setUi("step2");
  const url = new URL(window.location.href);
  url.searchParams.set("singularity", "step2");
  window.history.replaceState({}, "", url.toString());
}

export function setUiStoreToSingularityMode() {
  uiStore.setMode({
    mode: "builder",
    modifier: "singularity",
    singularityState: {
      // can we ditch this?
      step: window.Breakdance.singularity as "step1"
    }
  });
}

// we shouldn't need this, it shouldn't refresh the iframe
function iframeBs() {
  uiStore.setCanvasState("loading");
  configStore.setLeavingIframeOnPurpose(true);
}
